module.exports = __webpack_public_path__ + "static/img/contract.3d7e5019.png";